import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { Customer } from '@medusajs/medusa'
import { bhStoreApiRequest } from '@lib/request'

/** Return a boolean for whether or not the provided customer's account has
 * been approved by Barnhill or not. */
function useAccountApprovedCheck(customer?: Omit<Customer, 'password_hash'>) {
  const [loading, setLoading] = useState(false)
  const [isApproved, setIsApproved] = useState(false)
  const checkIsApproved = useCallback(async () => {
    setLoading(true)
    try {
      if (customer) {
        // check if the customer is a b2b customer
        const { data } = await bhStoreApiRequest<{
          isApproved: boolean
        }>(`/customers/is-approved`)
        setIsApproved(data.isApproved)
      } else {
        setIsApproved(false)
      }
    } catch (error) {
      setIsApproved(false)
    } finally {
      setLoading(false)
    }
  }, [customer])

  useEffect(() => {
    checkIsApproved()
  }, [checkIsApproved])

  return {
    isApproved,
    loading,
  }
}

export default useAccountApprovedCheck
